import type { Interpolation, Theme } from '@emotion/react';
import { cx } from '@linaria/atomic';

export type StylesProp = Interpolation<Theme>;

type EmotionStyles = Exclude<StylesProp, string | boolean | null | undefined>;

export type SplitStyles = {
  css?: EmotionStyles | EmotionStyles[];
  className?: string;
};

const EMPTY: SplitStyles = Object.freeze({ css: undefined, className: undefined });

export const splitStylesProp = (styles: StylesProp): SplitStyles => {
  if (!styles || styles === true) return EMPTY;
  if (typeof styles === 'string') return { css: undefined, className: styles };
  if (!Array.isArray(styles)) return { css: styles as EmotionStyles, className: undefined };

  const emotionStyles: EmotionStyles[] = [];
  const classNames: string[] = [];

  const visit = (value: StylesProp) => {
    if (!value || value === true) return;
    if (Array.isArray(value)) {
      for (const entry of value) visit(entry);
      return;
    }
    if (typeof value === 'string') {
      classNames.push(value);
      return;
    }
    emotionStyles.push(value as EmotionStyles);
  };

  visit(styles);

  if (!emotionStyles.length && !classNames.length) return EMPTY;

  return {
    css: emotionStyles.length ? emotionStyles : undefined,
    className: !classNames.length ? undefined : classNames.length === 1 ? classNames[0] : cx(...classNames),
  };
};
